import config from "../../config/environment.js";

export const reportMapaEntity = {
  friendlyPath: "mapa",
  path: config.endpoints.reportDateAndDni,
};
